let toastEl: HTMLDivElement | null = null;
let toastTimer: ReturnType<typeof setTimeout> | undefined;

function el(): HTMLDivElement | null {
    if (!toastEl) toastEl = document.querySelector<HTMLDivElement>('#toast');
    return toastEl;
}

export function showToast(msg: string): void {
    const toast = el();
    if (!toast) return;
    toast.textContent = msg;
    toast.style.opacity = '1';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => (toast.style.opacity = '0'), 3200);
}
